import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Form from '../../../commonComponents/forms/Form';
import translate from '../../../commonComponents/translate';
import Request from '../../../services/request';
import Notifications from '../../../services/notifications';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';

function NewsletterForm({ t, _csrf }) {
  const [email, setEmail] = useState('');
  const handleSubmit = () => {
    new Request(_csrf)
      .post('/subscribe/newsletter', { email })
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('success_subscribe_newsletter'),
        );
        window.location.reload();
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_subscribe_newsletter');
      });
  };

  const validationRules = { email: { required: true, email: true } };

  return (
    <Form
      className="landing-newsletter-form shop-main-newsletter-form"
      submitMethod={handleSubmit}
      id="subscribe-form"
      validationRules={validationRules}
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      {submitHandler => (
        <>
          <h5 className="landing-newsletter-title shop-main-newsletter-title">
            {t('landing_newsletter_title')}
          </h5>
          <div className="landing-newsletter-input-wrapper shop-main-newsletter-input-wrapper">
            <input
              name="email"
              type="email"
              className="landing-newsletter-input shop-main-newsletter-input"
              placeholder={t('landing_newsletter_email')}
              value={email}
              onChange={({ target }) => setEmail(target.value)}
            />
            <button
              type="button"
              className="landing-newsletter-button shop-main-newsletter-button btn btn-dynamic"
              onClick={submitHandler}
            >
              {t('subscribe')}
            </button>
          </div>
        </>
      )}
    </Form>
  );
}

NewsletterForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
};

export default compose(withCSRF, translate)(NewsletterForm);
